export function modal() {
  // jQueryが利用可能かチェック
  if (typeof jQuery === 'undefined') {
    console.warn('jQuery is not loaded. Modal functionality may not work properly.');
    return;
  }

  (function($){
    $(function(){
      // console.log('Modal function initialized'); // デバッグ用
      
      // 開く：.c-modal__trigger の data-modal と同じ data-modal を持つ .c-modal__wrapper を表示
      $(document).on('click', '.c-modal__trigger', function(e){
        e.preventDefault();
        // console.log('Modal trigger clicked'); // デバッグ用
        var modalId = $(this).data('modal');
        // console.log('Modal ID:', modalId); // デバッグ用
        var $target = $('.c-modal__wrapper[data-modal="' + modalId + '"]');
        // console.log('Target found:', $target.length); // デバッグ用
        // console.log('Target element:', $target[0]); // デバッグ用
        
        if(!$target.length){ 
          // console.log('No target found for modal ID:', modalId);
          return; 
        }
        
        // モーダルの現在の状態を確認
        // console.log('Modal current display:', $target.css('display'));
        // console.log('Modal current opacity:', $target.css('opacity'));
        
        $target.fadeIn(200);
        $target.find('.c-modal__container').scrollTop(0);
        $('html, body').css('overflow','hidden');
        
        // console.log('Modal should be visible now');
      });
      
      // 閉じる：背景(.c-modal__layer) or 閉じるボタン(.c-modal__close) or 戻るボタン(.c-modal__button)
      $(document).on('click', '.c-modal__layer, .c-modal__close, .c-modal__button', function(e){
        e.preventDefault();
        var $wrap = $(this).closest('.c-modal__wrapper');
        $wrap.fadeOut(200);
        $('html, body').removeAttr('style');
      });
      
      // Escキーでも閉じる
      $(document).on('keydown', function(e){
        if(e.key === 'Escape'){
          $('.c-modal__wrapper:visible').fadeOut(200);
          $('html, body').removeAttr('style');
        }
      });
      
    });
  })(jQuery);
}
 